var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", _vm._b({}, "table", _vm.$attrs, false), [
    _c(
      "thead",
      [
        _vm._t(
          "header",
          function () {
            return [
              _c(
                "tr",
                _vm._l(_vm.headers, function (header, column) {
                  return _c(
                    "th",
                    {
                      key: column,
                      class: {
                        sortable: true,
                        "active-sort": _vm.currentSortCriteria.some(
                          (c) => c.column === column
                        ),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.sort(column)
                        },
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(header.text) + " "),
                      _vm.getSortIndicator(column)
                        ? _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.getSortIndicator(column)) + " "
                            ),
                            _vm.multiSortEnabled &&
                            _vm.currentSortCriteria.length > 1
                              ? _c("small", [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.getSortOrderNumber(column)) +
                                      ")"
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]
          },
          { headers: _vm.headers, sort: _vm.sort }
        ),
      ],
      2
    ),
    _vm.displayedItems.length
      ? _c(
          "tbody",
          [
            _vm._t(
              "body",
              function () {
                return _vm._l(_vm.displayedItems, function (item, row) {
                  return _c(
                    "tr",
                    { key: row },
                    _vm._l(_vm.headers, function (header, column) {
                      return _c("td", { key: column }, [
                        _vm._v(" " + _vm._s(item[header.value]) + " "),
                      ])
                    }),
                    0
                  )
                })
              },
              { headers: _vm.headers, displayedItems: _vm.displayedItems }
            ),
          ],
          2
        )
      : _c("tbody", [
          _c("tr", [
            _c(
              "td",
              { attrs: { colspan: _vm.headers.length } },
              [
                _vm._t(
                  "no-results",
                  function () {
                    return [_vm._v(" No results. ")]
                  },
                  { search: _vm.search }
                ),
              ],
              2
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }